import { Editor, Node, Transforms } from 'slate';

import * as serializer from 'basic-editor-value-serializer';

import { moveItemSettings } from './wrap';

const types = serializer.types;

function clearItemSettings(editor, path) {

  const properties = { ...Node.get(editor, path).properties };

  delete properties.layoutItem;
  Transforms.setNodes(editor, { properties }, { at: path });

}

// The block takes the layout's place, and with it the layout's size in an outer layout.
function replaceLayoutWithChild(editor, layoutPath) {

  Editor.withoutNormalizing(editor, function replace() {
    clearItemSettings(editor, layoutPath.concat(0));
    moveItemSettings(editor, layoutPath, layoutPath.concat(0));
    Transforms.unwrapNodes(editor, { at: layoutPath });
  });

}

// Backspace in an empty block that is the only or the first child of a layout (spec 3.6). Every
// other empty block keeps today's behaviour. Returns true when it handled the key.
export function removeEmptyBlock(editor, path) {

  if (path.length < 2) {
    return false;
  }

  const parent = Node.parent(editor, path);

  if (parent.type !== types.LAYOUT) {
    return false;
  }

  if (parent.children.length === 1) {
    replaceLayoutWithChild(editor, path.slice(0, -1));
    return true;
  }

  if (path[path.length - 1] !== 0) {
    return false;
  }

  Transforms.removeNodes(editor, { at: path });
  Transforms.select(editor, Editor.start(editor, path));
  return true;

}
